// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1AF41","head":"Table_head__3doVc","col":"Table_col__xgbt4"};